import type { FaireProductEntity } from "../../entity_types/product";

export const p_gzsggtwjvt: FaireProductEntity = {
  token: "p_gzsggtwjvt",
  type: "product",
  name: "Silky Soy Sauce",
  brandToken: "b_5t38785gfm",
  brandName: "HEYDOH",
  imageUrl:
    "https://cdn.faire.com/fastly/c13559e708a4fd8d6169787e2839b545763af73e57388410b1fda9e2f0498030.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/39295b67a0a93dcacdd60b16c0443f098c9feb34ef1df8cf28b4483bbc704869.png",
    "https://cdn.faire.com/fastly/7e8a0e315ea0279cd1e8fc53b513b9ac0b06a988f9ca65fa6fc3d5ba586ade02.png",
    "https://cdn.faire.com/fastly/76c08e0490f02ec1aba5ede96986f2d187a13de028bbfe6f3cae12e689c249d0.png",
    "https://cdn.faire.com/fastly/f07f5ab0a33af41737bf22510d53e07056faaed93cbae9ab73452bf9df9d1631.png",
  ],
  priceDollars: 7.9,
  description:
    "This is a finishing sauce. It's luxurious and velvety, designed for dipping or drizzling. Brewed twice—first in salt water, then in soy sauce—it has a deeper umami backbone than others. A kiss of cane sugar gives it a glossy touch. With 50% less sodium than the big brands, Silky is like satin on the tongue. It's so good, you can sip it.\n\n200ml (6.8 fl oz)\n\nHow To Use:\nFor finishing, drizzling, and dipping. Drape over plain rice or avocado toast. Whisk it into vinaigrettes or gravy. Use as a dip for dumplings or spring rolls.",
  tags: [],
  msrpDollars: 13.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:51:42.332Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
